export default __webpack_public_path__ + "static/media/instagram.0f5767d2.png";